/*
  eslint no-underscore-dangle: ['error', {
    'allow': ['_INITIALIZED', '_ID']
  }]
*/

/*
  eslint no-param-reassign: ['error', {
    props: true,
    ignorePropertyModificationsFor: ['schema']
  }]
*/

import Vue from 'vue';

import { fallback } from '@sdk/helpers/misc/nullable';

function initialized(parent, id) {
  if (id) {
    let boolean = false;

    try {
      boolean = !!parent[id]._INITIALIZED;
    } catch (err) { /* */ }

    return boolean;
  }

  return !!parent._INITIALIZED;
}

export function initializeSchema(schema) {
  if (initialized(schema)) {
    return;
  }

  schema._INITIALIZED = true;
  schema.fields = Vue.observable({ ...schema.fields });
  schema.sections = Vue.observable({ ...schema.sections });
  schema.subsections = Vue.observable({ ...schema.subsections });
}

export function initializeSection(schema, id) {
  if (initialized(schema.sections, id)) {
    return;
  }

  const section = schema.sections[id] || {};

  schema.sections[id] = Vue.observable({
    ...section,

    _ID: id,
    _INITIALIZED: true,

    title: fallback(section.title, undefined),
    subtitle: fallback(section.subtitle, undefined),

    visible: fallback(section.visible, true),
    toggled: fallback(section.toggled, false),

    fields: Vue.observable({}),
  });
}

export function initializeSubsection(schema, id) {
  if (initialized(schema.subsections, id)) {
    return;
  }

  const subsection = schema.subsections[id];

  schema.subsections[id] = Vue.observable({
    ...subsection,

    _ID: id,
    _INITIALIZED: true,

    fields: Vue.observable({}),
  });
}

export function initializeField(schema, id, fields) {
  if (initialized(schema.fields, id)) {
    return;
  }

  const field = Vue.observable({
    ...fields[id],

    _ID: id,
    _INITIALIZED: true,

    section: fallback(fields[id].section, undefined),
    subsection: fallback(fields[id].subsection, undefined),
    data: Vue.observable(fallback(fields[id].data, {})),

    type: fallback(fields[id].type, 'text'),

    label: fallback(fields[id].label, undefined),
    labelless: fallback(fields[id].labelless, false),
    placeholder: fallback(fields[id].placeholder, undefined),
    size: fallback(fields[id].size, 3),

    value: fallback(fields[id].value, null),
    loading: fallback(fields[id].loading, false),
    disabled: fallback(fields[id].disabled, false),

    mask: Vue.observable(fallback(fields[id].mask, {})),
    options: Vue.observable(fallback(fields[id].options, [])),

    callback: fallback(fields[id].callback, undefined),

    visible: fallback(fields[id].visible, true),

    errors: Vue.observable(fallback(fields[id].errors, [])),
    validations: Vue.observable(fallback(fields[id].validations, [])),
  });

  // switch (field.type) {
  //   case 'select':
  //   case 'boolean':
  //   case 'radio':
  //     // options
  //     break;
  //   case 'text':
  //   default:
  //     // mask
  // }

  schema.fields[id] = field;
  schema.sections[field.section].fields[id] = schema.fields[id];
  schema.subsections[field.subsection].fields[id] = schema.fields[id];
}

export default function normalizer(schema, id, fields) {
  initializeSchema(schema);

  if (fields && id && fields[id].section) {
    initializeSection(schema, fields[id].section);
    initializeSubsection(schema, fields[id].subsection);

    initializeField(schema, id, fields);
  } else {
    Object
      .keys(fields || schema.fields)
      .forEach(k => normalizer(schema, k, fields || schema.fields));
  }

  return schema;
}
